/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV3ServiceCreateTemporaryTokenPost } from '../fn/covid/api-v-3-service-create-temporary-token-post';
import { ApiV3ServiceCreateTemporaryTokenPost$Params } from '../fn/covid/api-v-3-service-create-temporary-token-post';

@Injectable({ providedIn: 'root' })
export class ApiFromCovidService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV3ServiceCreateTemporaryTokenPost()` */
  static readonly ApiV3ServiceCreateTemporaryTokenPostPath = '/api/v3/service/CreateTemporaryToken';

  /**
   * Getting a temporary registration token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceCreateTemporaryTokenPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceCreateTemporaryTokenPost$Response(params?: ApiV3ServiceCreateTemporaryTokenPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceCreateTemporaryTokenPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a temporary registration token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceCreateTemporaryTokenPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceCreateTemporaryTokenPost(params?: ApiV3ServiceCreateTemporaryTokenPost$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceCreateTemporaryTokenPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
